<h1>Guides</h1>
<div mdcList>
  <a mdcListItem [routerLink]="['gettingstarted']">Getting Started</a>
  <a mdcListItem [routerLink]="['ie11']">Building for IE11</a>
  <a mdcListItem [routerLink]="['/components']">Components</a>
</div>
